import {persistor, store} from './store';
import {Provider} from 'react-redux';
import './App.css'
import {BrowserRouter as Router, useRoutes} from 'react-router-dom';
import WebRoutes from './routes/routes';
import {PersistGate} from 'redux-persist/integration/react';
import {NotificationContainer} from 'react-notifications';

const AppRoutes = () => {
    return useRoutes(WebRoutes);
};

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
      <Router>
      <AppRoutes />
          <NotificationContainer />
        </Router>
      </PersistGate>
    </Provider>
  )
}

export default App
